export const SET_ANSWER_LOADING = 'SET_ANSWER_LOADING'; 
export const SET_ANSWER = 'SET_ANSWER';
export const SET_ASK_MORE_LOADING = 'SET_ASK_MORE_LOADING';
export const SET_ASK_MORE = 'SET_ASK_MORE';